import { render, staticRenderFns } from "./distributionIndex.vue?vue&type=template&id=65f1816e&scoped=true"
import script from "./distributionIndex.vue?vue&type=script&lang=js"
export * from "./distributionIndex.vue?vue&type=script&lang=js"
import style0 from "./distributionIndex.vue?vue&type=style&index=0&id=65f1816e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1816e",
  null
  
)

export default component.exports